import React from "react"
import { motion } from "framer-motion"
import "./back.css"

const teamImages = [
  "/images/team/img1.jpg",
  "/images/team/img2.jpg",
  "/images/team/img3.jpg",
  "/images/team/img4.jpg",
  "/images/team/img5.jpg",
  "/images/team/img6.jpg",
];

const Back = ({ title, showImages = false, bgImage, heroImages }) => {

  return (
    <section 
      className={`back-section-hero ${bgImage ? 'has-bg-image' : ''}`}
      style={bgImage ? { backgroundImage: `url(${bgImage})` } : {}}
    >
      {/* Custom Hero Images for specific pages (like Events) */}
      {heroImages && heroImages.length > 0 && (
        <div className="hero-custom-images">
          {heroImages.map((src, index) => (
            <img key={index} src={src} alt="Hero decorative" className="hero-custom-img" />
          ))}
        </div>
      )}

      {/* Background Team Image Grid - only on About page */}
      {showImages && (
        <div className='back-image-grid'>
          {teamImages.map((src, index) => (
            <img key={index} src={src} alt="Team" className="back-grid-image" />
          ))}
        </div>
      )}

      <div className='back-overlay'></div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className='container'
      >
        <h1 className='back-title'>{title}</h1>
      </motion.div>
    </section>
  )
}

export default Back
